
import { PulseBaseProvider } from '../../base-classes';

const contentManagementUri = '/api/content/resources/location';
const contentManagementCacheKey = 'wbContentManagementCKey';

export class ContentManagementProvider extends PulseBaseProvider {
    constructor(baseUrl, authId, secret, options, logger) {
        super(baseUrl, authId, secret, options, logger);

        this.storage.sync[contentManagementCacheKey] = this.contentManagementSyncer.bind(this);
    }

    async contentManagementSyncer(params) {
        const { id, syncParams, resolve, reject } = params;

        let queryParams = {
            ...syncParams.stdParameters,
            resourcelist: syncParams.resourcelist,
            verbose: syncParams.verbose
        };

        return await super.syncData(syncParams.key, id, queryParams, contentManagementUri, resolve, reject, null, syncParams.pulseApi);

    }

    async getContentTemplate(verbose = false, stdParameters, resourcelist, refresh = false) {

        const syncParams = {
            verbose: verbose,
            refresh,
            resourcelist
        };

        const id = JSON.stringify(syncParams);

        syncParams.stdParameters = stdParameters;

        if (refresh) {
            super.removeFromStorage(contentManagementCacheKey, id);
        }

        return await super.loadFromStorage(contentManagementCacheKey, id, syncParams);
    }

}
